import { render, staticRenderFns } from "./BackToTopCopy.vue?vue&type=template&id=658ddcd0&scoped=true&"
import script from "./BackToTopCopy.vue?vue&type=script&lang=js&"
export * from "./BackToTopCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ddcd0",
  null
  
)

export default component.exports